module.exports = __webpack_public_path__ + "422dc78ce039a6a6496e2cbb0ed62eb4.woff";